Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.ExportableTable extends Backbone.View
  events:
    'click .download-image': 'onClickDownloadImage'

  _renderData: =>
    linkToImage = $('<a id="download-' + @id + '" class="download-image" style="float:right;cursor:pointer;"><i class="fa fa-download" style="font-size:20px;color:#000000"></i></a>')
    container = @$el.closest(".chart-container")
    titleContainer = container.find(".chart-title")
    titleContainer.append(linkToImage)
    linkContainer = titleContainer.find(".download-image")
    container.find(".fa-download").hide()
    container.hover (->
      $(this).find(".fa-download").show()
      return
    ), ->
      $(this).find(".fa-download").hide()
      return
    linkContainer.click (evt)=>
      @onClickDownloadImage(evt)
      return


  onClickDownloadImage: (evt) ->
    return if @linkExists
    evt.stopPropagation()
    @$el.closest(".chart-container").find('.download-image').hide()
    table = this.$el
    tablePlain = table[0]

    # scroll to center the table vertically

    elemTop = @$el.position().top
    viewportHeight = $(window).height()
    elementHeight = @$el.height()
    myScroll = elemTop - ((viewportHeight - elementHeight) / 2);

    $(window).scrollTop(myScroll);

    onrendered = (canvas) =>
      @$el.closest(".chart-container").find('.download-image').show()
      @$el.append(canvas)
      @$el.find('canvas').addClass('canvas').hide()
      @downloadCanvas(evt.currentTarget, 'canvas')
      @$el.find('canvas').remove()
    html2canvas(tablePlain, { onrendered: onrendered, timeout: 30000, useCORS: true })

  downloadCanvas: (link, canvasClass) ->
    filename = @$el.parent().parent().find(".chart-title")[0].innerHTML
    link.href = @$el.find('.' + canvasClass)[0].toDataURL()
    link.download = filename
    @linkExists = true
    @undelegateEvents()
    setTimeout () =>
      link.click()
      @delegateEvents()
    , 800
